const destinations = [
  {
    name: "Canada",
    context: "Snowbird season returns to British Columbia, Alberta, and Ontario — the single largest travel pattern from Apache Junction",
    urgency: "September–October rush as snowbirds prepare to depart Arizona; passports discovered expired during summer storage",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico (Baja & Rocky Point)",
    context: "RV road trips to Puerto Peñasco, Baja California coastal routes, and extended stays in Sonora beach towns",
    urgency: "Winter departure window Oct–Nov; passport card vs. book decisions often made last-minute",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico City & Cancún",
    context: "East Valley corporate travel to manufacturing facilities, tech conferences, and resort vacations from PHX",
    urgency: "Business travel often confirmed 7–14 days before departure — expedited processing essential",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Europe",
    context: "Heritage tourism, river cruises, and retirement bucket-list travel to Italy, Ireland, Germany, and Portugal",
    urgency: "Retirees planning once-in-a-lifetime trips often discover expired passports months before travel",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "New Zealand & Australia",
    context: "Long-haul adventure travel and winter escape for outdoor enthusiasts from the Superstition Mountain community",
    urgency: "Southern hemisphere winter trips (May–Sep) create a spring renewal rush; long flights require solid validity",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Costa Rica & Patagonia",
    context: "Eco-tourism, adventure hiking, and wildlife travel popular with the outdoor culture around Apache Junction",
    urgency: "Seasonal expedition windows are fixed — missing a trip start date due to passport delays is costly",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "Oct–Nov",
    label: "peak passport urgency window as snowbirds prepare for their annual Arizona departure",
  },
  {
    stat: "#1 Pattern",
    label: "expired U.S. passport discovered during fall pre-trip checklist before Canadian return",
  },
  {
    stat: "2–4 Weeks",
    label: "typical notice Apache Junction travelers have before a planned Mexico or Canada trip",
  },
  {
    stat: "180+ Miles",
    label: "distance to Phoenix Passport Agency — making courier service the practical choice",
  },
];

export default function ApacheJunctionDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Apache Junction Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Pinal County and East Valley clients. Understanding local travel behavior is part of why our document review catches issues before they derail your snowbird season, RV trip, or adventure expedition.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Arizona Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Arizona with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/avondale" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Avondale <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/buckeye" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Buckeye <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/states/arizona" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                All Arizona Cities <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}